import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ siteMaxWidth }: Theme) => ({
  root: {
    maxWidth: siteMaxWidth,
  },
}));
